import * as React from 'react';

function BatteryIcon(props) {
	return (
		<svg xmlns='http://www.w3.org/2000/svg' width={16} height={16} viewBox='0 0 16 16' fill='none' {...props}>
			<g clipPath='url(#clip0_3703_10746)'>
				<path
					d='M14.667 7.333v1.333M4 7.333v1.333m2.667-1.333v1.333m-4-4h8C11.403 4.667 12 5.264 12 6v4c0 .736-.597 1.333-1.333 1.333h-8A1.333 1.333 0 011.333 10V6c0-.737.597-1.333 1.334-1.333z'
					stroke='#545454'
					strokeWidth={1.33333}
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
			</g>
			<defs>
				<clipPath id='clip0_3703_10746'>
					<path fill='#fff' d='M0 0H16V16H0z' />
				</clipPath>
			</defs>
		</svg>
	);
}

export default BatteryIcon;
